export const INTEGRATION_TYPE = {
  MANAGED_BY_ATS: "MANAGED_BY_ATS",
  MANAGED_BY_COMPANY: "MANAGED_BY_COMPANY",
};
